{
  "nav": {
    "home": "Strona główna",
    "about": "O mnie",
    "video": "Wideo",
    "classes": "Zajęcia",
    "passes": "Karnety",
    "bookings": "Rezerwacje",
    "profile": "Profil",
    "admin": "Admin",
    "menu": "Otwórz nawigację",
    "close": "Zamknij nawigację"
  },
  "profile": {
    "title": "Mój profil",
    "loading": "Ładowanie profilu...",
    "errorLoading": "Nie udało się załadować profilu. Spróbuj ponownie.",
    "retry": "Ponów",
    "email": "E-mail",
    "name": "Imię i nazwisko",
    "phone": "Telefon",
    "dateOfBirth": "Data urodzenia",
    "notes": "Uwagi zdrowotne / preferencje",
    "save": "Zapisz",
    "saving": "Zapisywanie...",
    "saved": "Profil zapisany.",
    "saveError": "Nie udało się zapisać profilu. Spróbuj ponownie."
  },
  "app": {
    "name": "Holistic Flow"
  },
  "home": {
    "hero": {
      "title": "Pilates, który zmienia nie tylko ciało",
      "subtitle": "Odkryj klasyczny pilates prowadzony przez doświadczoną instruktorkę. Zajęcia prowadzone na żywo i biblioteka nagranych treningów są teraz jeszcze bardziej dostępne.",
      "imageAlt": "Pilates",
      "ctaPrimary": "Zacznij teraz",
      "ctaSecondary": "Przedź do treningów"
    },
    "about": {
      "tagline": "Moja historia",
      "title": "Pilates z pasją i doświadczeniem",
      "description": "Od 2020 roku prowadzę zajęcia online, budując społeczność ludzi, którzy wierzą w moc klasycznego pilatesu. Każda lekcja to połączenie precyzji, spokoju i uśmiechu.",
      "features": [
        "Ponad sześć lat doświadczenia w pilatesie klasycznym",
        "Stała grupa zadowolonych uczestników zajęć online",
        "Liczne certyfikaty i szkolenia specjalistyczne"
      ],
      "imageAlt": "Instruktorka pilates",
      "cta": "O mnie"
    },
    "pillars": {
      "tagline": "Filary",
      "title": "Trzy sposoby na transformację ciała",
      "description": "Każdy element platformy Holistic Flow został zaprojektowany z myślą o Twojej praktyce. Niezależnie od tego, czy wolisz pracować w swoim tempie, czy szukasz energii zajęć na żywo, mamy dla Ciebie rozwiązanie.",
      "items": [
        {
          "title": "Biblioteka VOD",
          "description": "Dostęp do setek lekcji dostępnych zawsze, kiedy ich potrzebujesz."
        },
        {
          "title": "Zajęcia Live",
          "description": "Połącz się z instruktorką i innymi uczestnikami w czasie rzeczywistym."
        },
        {
          "title": "Kursy",
          "description": "Uporządkowane kursy, które strukturyzują Twój rozwój i pomagają osiągnąć konkretne cele."
        }
      ],
      "cta": "Odkryj"
    },
    "benefits": {
      "tagline": "Rezultaty",
      "title": "Co zyskujesz z regularną praktyką",
      "description": "Pilates to więcej niż ćwiczenia. To droga do lepszego samopoczucia, silniejszego ciała i spokojniejszego umysłu. Każda lekcja pomaga Ci zwiększyć świadomość własnego ciała i działa na nie lepiej niż niejeden masaż.",
      "imageAlt": "Benefity pilates",
      "cta": "Zacznij"
    },
    "pricing": {
      "tagline": "Pakiety",
      "title": "Cennik",
      "description": "Wybierz plan, który pasuje do Twojego stylu życia.",
      "validity": "{days} dni",
      "cta": "Zacznij"
    },
    "testimonials": {
      "title": "Co mówią uczestnicy",
      "items": [
        {
          "quote": "Nareszcie odnalazłam zajęcia, w których wytrwałam dłużej niż 3 miesiące! Najbardziej wdzięczny za treningi jest mój kręgosłup!",
          "author": "Iwona",
          "role": "Uczestniczka zajęć online od 2021 roku"
        },
        {
          "quote": "Mam ponad 50 lat i staram się łączyć pracę zawodową z aktywnym trybem zycia. Pilates z Agatą wspiera mnie w realizacji moich pasji, a ja nie łapię żadnych kontuzji.",
          "author": "Magdalena",
          "role": "Uczestniczka zajęć online od 2020 roku"
        },
        {
          "quote": "Bardzo fajnie się ćwiczy z nagranymi treningami, czasem robię od razu 3! Wszystko dokładnie wyjaśnione, dzięki czemu wiem co robić. Podoba mi się spokój, z którym Agata prowadzi treningi.",
          "author": "Julia",
          "role": "Regularnie ćwiczy z filmikami"
        }
      ]
    },
    "faq": {
      "title": "Najczęściej zadawane pytania",
      "items": [
        {
          "question": "Czy mogę zacząć pilates, jeśli nigdy tego nie robiłam?",
          "answer": "Oczywiście! Moje kursy są dostosowane dla każdego poziomu zaawansowania, od początkujących po zaawansowanych. Każda osoba pracuje na swoim poziomie."
        },
        {
          "question": "Jaka jest różnica między zajęciami live a VOD?",
          "answer": "Zajęcia live oferują bezpośrednią interakcję ze mną i innymi uczestnikami w czasie rzeczywistym, dzieki temu ja mogę na bieżąco korygować ćwiczenia i dostosowywać je do potrzeb grupy, a Ty dajesz znać czy wszystko ok i czerpiesz energię grupy. VOD daje Ci elastyczność - możesz ćwiczyć o dowolnej porze."
        },
        {
          "question": "Co jeśli mam problemy zdrowotne lub uraz?",
          "answer": "Ćwiczenia pilates mogą być dostosowane niemal do każdego. Jeśli potrzebujesz indywidualnej konsultacji skontaktuj się ze mną mailowo."
        }
      ]
    },
    "cta": {
      "title": "Gotowa do transformacji?",
      "subtitle": "Dołącz do setek uczestników, którzy już zmienili swoje życie poprzez pilates.",
      "button": "Zacznij już dziś"
    }
  },
  "video": {
    "loading": "Ładowanie lekcji...",
    "errorLoading": "Nie udało się załadować lekcji. Spróbuj ponownie.",
    "retry": "Ponów",
    "empty": "Brak dostępnych lekcji.",
    "duration": "{minutes} min",
    "category": {
      "pre-pilates": "Pre-pilates",
      "abs": "Brzuch",
      "glutes": "Pośladki",
      "ball": "Piłka",
      "order": "Order",
      "youtube": "YouTube"
    },
    "equipment": {
      "mat": "Mata",
      "ball": "Piłka",
      "weights": "Ciężarki",
      "ring": "Obręcz",
      "stick": "Kij",
      "roller": "Wałek",
      "reformer": "Reformer"
    },
    "difficultyLabel": "Poziom zaawansowania",
    "difficultyValue": "Poziom {level} z {max}",
    "thumbnailAlt": "Miniatura lekcji {title}",
    "page": {
      "hero": {
        "title": "Biblioteka treningów",
        "subtitle": "Dostęp do nagranych lekcji pilatesu klasycznego dostępnych 24/7. Ćwicz gdzie i kiedy chcesz z Holistic Flow.",
        "ctaPrimary": "Wykup dostęp",
        "ctaSecondary": "Przeglądaj lekcje"
      },
      "benefits": {
        "tagline": "Zalety",
        "title": "Ćwicz na swoich warunkach",
        "description": "Dostęp do lekcji o każdej porze dnia i nocy. Twój harmonogram, twoja praktyka, twoje tempo.",
        "items": [
          {
            "title": "Lekcje dla każdego poziomu",
            "description": "Od pierwszych kroków do zaawansowanych sekwencji, znajdziesz dokładnie to czego potrzebujesz."
          },
          {
            "title": "Postęp bez pośpiechu",
            "description": "Rozwijaj się w swoim tempie bez presji i porównań z innymi."
          },
          {
            "title": "Profesjonalna opieka",
            "description": "Każda lekcja prowadzona jest przez doświadczoną nauczycielkę klasycznego pilatesu."
          }
        ]
      },
      "listTitle": "Dostępne lekcje"
    },
    "detail": {
      "breadcrumb": "Biblioteka VOD",
      "notFound": "Nie znaleziono lekcji.",
      "backToList": "Wróć do biblioteki",
      "equipmentTitle": "Wymagany sprzęt",
      "equipmentEmpty": "Do tej lekcji nie potrzebujesz żadnego sprzętu.",
      "descriptionEmpty": "Opis tej lekcji pojawi się wkrótce.",
      "ctaPrimary": "Zacznij lekcję",
      "ctaSecondary": "Kup dostęp",
      "accordionDetailsTitle": "Szczegóły lekcji",
      "accordionDetailsContent": "Lekcja obejmuje rozgrzewkę, część główną skoncentrowaną na kluczowych elementach pilatesu, oraz chłodzenie. Każdy ruch jest wyjaśniony krok po kroku, aby zagwarantować bezpieczeństwo i efektywność.",
      "testimonialsTitle": "Co mówią uczestniczki",
      "testimonials": [
        {
          "quote": "Ta lekcja zmieniła moje życie! Czuję się silniejsza i bardziej elastyczna.",
          "author": "Anna K.",
          "role": "Uczestniczka"
        },
        {
          "quote": "Instruktorka jest niesamowita. Każdy ruch jest wytłumaczony dokładnie.",
          "author": "Maria S.",
          "role": "Uczestniczka"
        },
        {
          "quote": "Polecam wszystkim moim przyjaciołom. Warto spróbować tej lekcji!",
          "author": "Katarzyna M.",
          "role": "Uczestniczka"
        }
      ],
      "ctaTitle": "Gotowa na zmianę?",
      "ctaSubtitle": "Dołącz do setek uczestniczek, które już ćwiczą tę lekcję.",
      "ctaButton": "Zaloguj się lub kup dostęp",
      "play": "Odtwórz lekcję",
      "playbackError": "Nie udało się uruchomić wideo. Spróbuj ponownie."
    }
  },
  "classes": {
    "loading": "Ładowanie zajęć...",
    "errorLoading": "Nie udało się załadować zajęć. Spróbuj ponownie.",
    "retry": "Ponów",
    "empty": "Brak nadchodzących zajęć.",
    "newClass": "Nowe zajęcia",
    "edit": "Edytuj",
    "cancel": "Odwołaj zajęcia",
    "confirmCancel": "Odwołać te zajęcia? Tej operacji nie można cofnąć.",
    "forceDelete": "Usuń trwale",
    "confirmForceDelete": "Trwale usunąć te zajęcia? Zostaną usunięte z bazy danych i nie będzie można ich odzyskać.",
    "saveError": "Nie udało się zapisać zajęć. Spróbuj ponownie.",
    "cancelError": "Nie udało się odwołać zajęć. Spróbuj ponownie.",
    "forceDeleteError": "Nie udało się usunąć zajęć. Spróbuj ponownie.",
    "status": {
      "scheduled": "Zaplanowane",
      "cancelled": "Odwołane"
    },
    "enrolled": "{enrolled} / {capacity}",
    "form": {
      "createTitle": "Nowe zajęcia",
      "editTitle": "Edytuj zajęcia",
      "title": "Tytuł",
      "instructor": "Instruktor",
      "scheduledAt": "Data i godzina",
      "duration": "Czas trwania (minuty)",
      "capacity": "Liczba miejsc",
      "description": "Opis",
      "save": "Zapisz",
      "saving": "Zapisywanie...",
      "close": "Zamknij"
    },
    "page": {
      "hero": {
        "title": "Zajęcia na żywo",
        "subtitle": "Ćwicz pilates online na żywo z doświadczoną instruktorką. Dowiedz się więcej o naszych zajęciach i zarezerwuj swoje miejsce już dzisiaj.",
        "ctaPrimary": "Dołącz",
        "ctaSecondary": "Harmonogram"
      },
      "steps": [
        {
          "number": "01",
          "title": "Wybierz zajęcia",
          "description": "Przejrzyj harmonogram i znajdź idealne dla siebie"
        },
        {
          "number": "02",
          "title": "Zarezerwuj miejsce",
          "description": "Wybierz swoją datę i zarezerwuj miejsce w grupie"
        },
        {
          "number": "03",
          "title": "Dołącz do sesji",
          "description": "Zaloguj się o wyznaczonym czasie i ćwicz online"
        }
      ],
      "scheduleTitle": "Harmonogram zajęć"
    },
    "duration": "{minutes} min"
  },
  "passes": {
    "myPass": "Mój karnet",
    "passTypes": "Rodzaje karnetów",
    "loading": "Ładowanie karnetów...",
    "errorLoading": "Nie udało się załadować karnetów. Spróbuj ponownie.",
    "retry": "Ponów",
    "emptyTypes": "Brak dostępnych karnetów.",
    "noActivePass": "Nie masz aktywnego karnetu.",
    "newPassType": "Nowy karnet",
    "edit": "Edytuj",
    "saveError": "Nie udało się zapisać karnetu. Spróbuj ponownie.",
    "grantSuccess": "Karnet przyznany, ważny do {date}.",
    "grantError": "Nie udało się przyznać karnetu. Spróbuj ponownie.",
    "entriesRemaining": "Pozostało wejść: {entries}",
    "unlimited": "Bez limitu",
    "validUntil": "Ważny do {date}",
    "status": {
      "active": "Aktywny",
      "expired": "Wygasły",
      "exhausted": "Wyczerpany",
      "cancelled": "Anulowany"
    },
    "form": {
      "createTitle": "Nowy karnet",
      "editTitle": "Edytuj karnet",
      "name": "Nazwa",
      "entries": "Liczba wejść",
      "unlimitedLabel": "Bez limitu",
      "price": "Cena (zł)",
      "currency": "Waluta",
      "validityDays": "Ważność (dni)",
      "paymentUrl": "Link do płatności",
      "save": "Zapisz",
      "saving": "Zapisywanie...",
      "close": "Zamknij"
    },
    "grantForm": {
      "title": "Przyznaj karnet",
      "user": "Użytkownik",
      "selectUser": "Wybierz użytkownika",
      "loadingUsers": "Ładowanie użytkowników...",
      "me": "ja",
      "passType": "Rodzaj karnetu",
      "selectPassType": "Wybierz karnet",
      "submit": "Przyznaj",
      "submitting": "Przyznawanie..."
    },
    "page": {
      "subtitle": "Wybierz plan, który pasuje do Ciebie",
      "myPass": {
        "text": "Przejdź do swojego profilu, aby zobaczyć aktywny karnet i liczbę pozostałych wejść."
      },
      "buy": {
        "title": "Kup karnet",
        "text": "Dostępne pakiety i cennik znajdują się na stronie głównej w sekcji „Pakiety”."
      },
      "manage": {
        "title": "Zarządzaj karnetami",
        "text": "Przejdź do panelu administracyjnego, aby zarządzać karnetami i przyznawać je użytkownikom.",
        "cta": "Panel admina"
      }
    },
    "deleteConfirm": "Na pewno chcesz trwale usunąć ten karnet? Tej operacji nie można cofnąć.",
    "deleteError": "Błąd podczas usuwania karnetu",
    "entriesCount": "{entries} wejść",
    "validityShort": "{days}d"
  },
  "bookings": {
    "loading": "Ładowanie rezerwacji...",
    "errorLoading": "Nie udało się załadować rezerwacji. Spróbuj ponownie.",
    "retry": "Ponów",
    "empty": "Brak rezerwacji.",
    "emptyCancelled": "Brak anulowanych rezerwacji.",
    "showCancelled": "Pokaż anulowane",
    "hideCancelled": "Ukryj anulowane",
    "forceDelete": "Usuń trwale",
    "confirmForceDelete": "Trwale usunąć ten rekord rezerwacji?",
    "forceDeleteError": "Nie udało się usunąć rezerwacji. Spróbuj ponownie.",
    "bookClass": "Zarezerwuj",
    "alreadyBooked": "Już zarezerwowano",
    "classFull": "Brak miejsc",
    "classCancelled": "Te zajęcia zostały odwołane.",
    "classAlreadyStarted": "Te zajęcia już się rozpoczęły.",
    "noActivePass": "Aby zarezerwować zajęcia, potrzebujesz aktywnego karnetu.",
    "noPassEntries": "Twój karnet nie ma już dostępnych wejść.",
    "bookError": "Nie udało się zarezerwować. Spróbuj ponownie.",
    "cancel": "Anuluj rezerwację",
    "cancelConfirm": "Anulować tę rezerwację?",
    "cancelError": "Nie udało się anulować rezerwacji. Spróbuj ponownie.",
    "entryReturned": "Wejście zwrócone na karnet.",
    "entryNotReturned": "Rezerwacja anulowana. Wejście nie zostało zwrócone.",
    "roster": "Lista uczestników",
    "rosterLoading": "Ładowanie listy...",
    "rosterEmpty": "Brak rezerwacji na te zajęcia.",
    "status": {
      "confirmed": "Potwierdzona",
      "cancelled": "Anulowana"
    },
    "sourceAuto": "auto"
  },
  "about": {
    "hero": {
      "tagline": "Twoja nauczycielka",
      "name": "Agata Wójcik",
      "bio": "Od 2020 roku prowadzę zajęcia pilatesu klasycznego, ukończyłam zaawansowane szkolenia obejmujące matę, sprzęt, anatomię ruchu, schorzenia kręgosłupa, mięśnie dna miednicy i pilates dla kobiet w ciąży. Moja praktyka dociera do uczestników z całego świata.",
      "imageAlt": "Agata Wójcik — instruktorka pilatesu klasycznego",
      "ctaPrimary": "Zarezerwuj",
      "ctaSecondary": "Odkryj"
    },
    "trainings": {
      "tagline": "Skąd czerpię wiedzę?",
      "title": "Ukończone szkolenia, warsztaty",
      "description": "Pilates to dla mnie niekończąca się podróż ucząca pokory wobec własnego ciała, dlatego regularnie biorę udział w szkoleniach i warsztatach, ucząc się od najlepszych nauczycieli w Polsce.",
      "items": [
        {
          "title": "Pilates Comprehensive II",
          "details": "2026, Clinical Pilates School: Adrianna Chruściel, Gdynia",
          "description": "Kompleksowe półroczne szkolenie z pilatesu klasycznego obejmujące ćwiczenia na poziomie średniozaawansowanym na macie, reformerze, cadillacu, wieży, krzesłach i beczkach. Program szkolenia obejmował zarówno teorię i biomechanikę ruchu w każdym ćwiczeniu, praktykę własną, jak i praktykę prowadzenia zajęć grupowych i indywidualnych."
        },
        {
          "title": "Pilates dla kobiet w ciąży",
          "details": "2025, Kornelia Mulak, Dagmara Czeran, Gdańsk",
          "description": "Szkolenie przygotowujące do prowadzenia zajęć dla kobiet w ciąży na macie oraz pilatesowych sprzętach."
        },
        {
          "title": "Prowadzenie zajęć grupowych pilates",
          "details": "2024, Anna Tytus, Gdańsk",
          "description": "2-dniowy warsztat przygotowujący do prowadzenia zajęć grupowych pilatesu klasycznego, obejmujący metodykę, komunikację i bezpieczeństwo uczestników zajęć grupowych."
        },
        {
          "title": "Mięśnie dna miednicy w ćwiczeniach pilates",
          "details": "2023, Clinical Pilates School: Adrianna Chruściel, Gdynia",
          "description": "Szkolenia z zakresu anatomii i funkcjonowania mięśni dna miednicy oraz ich roli w pilatesie."
        },
        {
          "title": "Pilates Chair",
          "details": "2023, Karolina Libelt, Sopot",
          "description": "1-dniowy warsztat z zakresu ćwiczeń na pilatesowym krześle, obejmujący ćwiczenia na wszystkich poziomach zaawansowania"
        },
        {
          "title": "Pilates w wadach i schorzeniach kręgosłupa: sprzęty",
          "details": "2022, Magdalena Nowak, Gdynia",
          "description": "Szkolenie z fizjoterapeutką z zakresu pracy z osobami z wadami i schorzeniami kręgosłupa, obejmujące ćwiczenia na pilatesowych sprzętach."
        },
        {
          "title": "Pilates w wadach i schorzeniach kręgosłupa: mata i małe dodatki",
          "details": "2021, Magdalena Nowak, Gdynia",
          "description": "Szkolenie z fizjoterapeutką z zakresu pracy z osobami z wadami i schorzeniami kręgosłupa, obejmujące ćwiczenia na macie i z wykorzystaniem małych przyborów."
        },
        {
          "title": "Peak Pilates Basic Mat I",
          "details": "2020, Karolina Libelt, Sopot",
          "description": "Certyfikowane szkolenie z zakresu pilatesu klasycznego na macie na poziomie podstawowym, obejmujące 30 godzin szkolenia, 30 godzin obserwacji oraz 30 godzin prowadzenia treningów."
        },
        {
          "title": "Pilates Fundamentals",
          "details": "2020, Karolina Libelt, Online",
          "description": "2-godzinny warsztat omawiający ćwiczenia pre-pilatesowe, podstawy pracy z oddechem i aktywacji mięśni głębokich."
        },
        {
          "title": "Pilates z Magic Ring",
          "details": "2020, Karolina Libelt, Online",
          "description": "2-godzinny warsztat z zakresu ćwiczeń z wykorzystaniem magic ring"
        }
      ]
    },
    "stats": {
      "tagline": "Liczby",
      "title": "Lata praktyki... i to dopiero początek",
      "description": "Od 2020 roku prowadzę zajęcia, które zmieniły życie wielu osób. Liczby poniżej odzwierciedlają ich ilość, ale to jakość gra tutaj zawsze pierwsze skrzypce.",
      "cta": "Dołącz",
      "items": [
        {
          "number": "6",
          "label": "Lat doświadczenia"
        },
        {
          "number": "1000+",
          "label": "Przeprowadzonych zajęć online"
        },
        {
          "number": "18",
          "label": "Nagranych treningów"
        }
      ]
    },
    "values": {
      "tagline": "Wartości",
      "title": "To co mnie napędza",
      "description": "Wierzę w moc spokoju i konsekwencji. Nauczam pilatesu, ale uczę przede wszystkim słuchania siebie.",
      "items": [
        {
          "title": "Spokój",
          "subtitle": "Fundamentem",
          "description": "Każda lekcja to przestrzeń wolna od pośpiechu. Tutaj czas płynie inaczej."
        },
        {
          "title": "Zaufanie",
          "subtitle": "Budowane powoli",
          "description": "Pracuję z tobą, nie dla ciebie. Twoje ciało wie co potrzebuje. Ja tylko słucham."
        },
        {
          "title": "Profesjonalizm",
          "subtitle": "Bez kompromisów",
          "description": "Od 2020 roku doskonalę swoją praktykę. Każda lekcja to wynik lat doświadczenia i nauki."
        },
        {
          "title": "Konsekwencja",
          "subtitle": "Zmiana wymaga czasu",
          "description": "Pilates to nie sprint. To maraton, w którym każdy krok ma znaczenie i wartość."
        },
        {
          "title": "Indywidualność",
          "subtitle": "Twoja droga",
          "description": "Nie ma standardowych ciał ani standardowych potrzeb. Dostosowuję każde ćwiczenie do ciebie."
        },
        {
          "title": "Autentyczność",
          "subtitle": "Bez maski",
          "description": "Nauczam tego, co praktykuję każdego dnia. Moje słowa mają wagę, bo sama nimi żyję."
        },
        {
          "title": "Ciągły rozwój",
          "subtitle": "Nigdy nie przestaję",
          "description": "Pilates to kompleksowy system ćwiczeń. Nie ustaję w studiowaniu go, aby przekazywać ci go najlepiej jak to możliwe."
        },
        {
          "title": "Wspólnota",
          "subtitle": "Razem silniejsi",
          "description": "Choć zajęcia mogą być online, energia jest rzeczywista. Jesteśmy częścią czegoś większego."
        }
      ]
    },
    "explore": {
      "title": "Sprawdź, co dla Ciebie przygotowałam",
      "cards": {
        "classes": {
          "title": "Zajęcia",
          "description": "Przeglądaj nadchodzące zajęcia i zarezerwuj miejsce."
        },
        "passes": {
          "title": "Karnety",
          "description": "Twoje wejścia na zajęcia — jednorazowe lub miesięczne."
        },
        "bookings": {
          "title": "Rezerwacje",
          "description": "Zobacz i zarządzaj swoimi rezerwacjami."
        },
        "videos": {
          "title": "Nagrane treningi pilatesu",
          "description": "Ćwicz ze mną w klasycznym nurcie pilatesu o każdej porze — bez rezerwacji."
        }
      }
    }
  },
  "notFound": {
    "title": "Nie znaleziono strony",
    "description": "Strona, której szukasz, nie istnieje lub została przeniesiona.",
    "returnHome": "Wróć na stronę główną"
  },
  "player": {
    "loading": "Ładowanie wideo...",
    "error": "Nie można załadować wideo",
    "errorHint": "Link do wideo mógł wygasnąć. Kliknij poniżej, aby odświeżyć.",
    "reload": "Odśwież wideo",
    "unsupported": "Twoja przeglądarka nie obsługuje znacznika wideo."
  },
  "auth": {
    "login": "Zaloguj się",
    "logout": "Wyloguj się",
    "loading": "Uwierzytelnianie...",
    "callback": {
      "processing": "Logowanie...",
      "error": "Uwierzytelnianie nie powiodło się. Spróbuj ponownie.",
      "retry": "Spróbuj ponownie"
    },
    "error": {
      "config": "Usługa uwierzytelniania niedostępna"
    },
    "user": {
      "menu": "Menu użytkownika",
      "role": {
        "admin": "Admin",
        "instructor": "Instruktor",
        "user": "Użytkownik"
      }
    }
  },
  "admin": {
    "subtitle": "Zarządzaj platformą"
  }
}
